import { allContractorSubscriptionPlanOptions, contractorStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import ContractorCompanyName from "components/table/columnComponents/ContractorCompanyName"
import ContractorInstalledDevicesCount from "components/table/columnComponents/ContractorInstalledDevicesCount"
import ContractorWarrantyDevicesCount from "components/table/columnComponents/ContractorWarrantyDevicesCount"

export const contractorTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Company name",
    type: "sort-search",
    name: "name",
    cellComponent: ContractorCompanyName,
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
  },
  {
    title: "Brand Name",
    type: "sort-search",
    name: "brand",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
  },
  {
    title: "Creation Date",
    type: "sort-date-range",
    name: "create_date",
  },
  {
    title: "Subscription Plan",
    type: "select",
    name: "subscription_plan",
    options: allContractorSubscriptionPlanOptions,
  },
  {
    title: "Purchased Devices",
    type: "sort-search",
    name: "purchased",
  },
  {
    title: "Installed Devices",
    type: "sort-search",
    name: "installed",
    cellComponent: ContractorInstalledDevicesCount,
  },
  {
    title: "Installed Last 7 days",
    type: "sort",
    name: "install_7_day",
  },
  {
    title: "Activated mobile apps",
    type: "sort",
    name: "active_mobile",
  },
  {
    title: "Inventory",
    type: "sort-search",
    name: "inventory",
  },
  {
    title: "Warranty",
    type: "sort-search",
    name: "warranty",
    cellComponent: ContractorWarrantyDevicesCount,
  },
  {
    title: "Status",
    type: "select",
    name: "isEnabled",
    options: contractorStatusOptions,
    cellComponent: "boolean",
  },
]
